export default "__VITE_ASSET__l_l4gWSIg7Fg90WkEXHA5g__"